import React from 'react';

import ArticleIcon from '@mui/icons-material/Article';
import { useTheme } from '@mui/material/styles';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DropdownCardMenu from 'common/components/DropdownCardMenu';
import { TEMPLATE_TYPES } from 'common/constants';

import SideMenuCard from './SideMenuCard';

const ProposalCard = ({
    document,
    handleClickDocumentItem,
    handleClickEditButton,
    isDisabled,
    selectedDocumentId,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <SideMenuCard
            icon={<ArticleIcon sx={{ color: 'primary.main' }} />}
            title={t('Proposal')}
        >
            <List disablePadding>
                <ListItem
                    disabled={isDisabled || document.id === selectedDocumentId}
                    disablePadding
                    key={`proposal-${document.id}`}
                    secondaryAction={
                        <DropdownCardMenu
                            disabled={isDisabled}
                            items={[
                                {
                                    handleClick: () => handleClickEditButton(),
                                    label: t('Edit'),
                                },
                            ]}
                            sxIconButton={{
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            }}
                            visible={false}
                        />
                    }
                    selected={document.id === selectedDocumentId}
                    sx={{
                        borderRadius: '8px',
                        mb: '5px',
                        '&.Mui-selected': {
                            backgroundColor:
                                theme.palette.mode === 'dark'
                                    ? '#000'
                                    : 'rgba(31, 60, 83, 0.13)',
                        },
                    }}
                >
                    <ListItemButton
                        onClick={() =>
                            handleClickDocumentItem({
                                contentId: get(document, 'content.id', null),
                                id: document.id,
                                name: document.name,
                                type: TEMPLATE_TYPES.PROPOSAL_TYPE,
                            })
                        }
                        sx={{ borderRadius: '8px' }}
                    >
                        <ListItemText
                            primary={document.name}
                            sx={{
                                '.MuiListItemText-primary': {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            }}
                        />
                    </ListItemButton>
                </ListItem>
            </List>
        </SideMenuCard>
    );
};

ProposalCard.propTypes = {
    document: PropTypes.object,
    handleClickDocumentItem: PropTypes.func,
    handleClickEditButton: PropTypes.func,
    isDisabled: PropTypes.bool,
    selectedDocumentId: PropTypes.string,
};

export default ProposalCard;
